export default __webpack_public_path__ + "media/images/btn_dropdown-54076ac3.png";